import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { sendCntVideo, updateVideoForm } from '../types/api';
import { useUser } from '../context/UserContext';
import { useLanguage } from "../context/LanguageContext";
import '../style/VideoForm.css'; // Import your CSS file

const VideoFormCnt: React.FC = () => {
  const videoRef = useRef<HTMLDivElement>(null);
  const playerRef = useRef<any>(null); // Store YouTube player instance
  const navigate = useNavigate();
  const location = useLocation();
  //const { name, mobile, whatsapp, language, email, country, state, district, city, pinCode } = location.state || {};
  const { setUser, user } = useUser();
  
  const [loading, setLoading] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);

  const [volume, setVolume] = useState(100);
  const [isMuted, setIsMuted] = useState(false);
  const [currentTime, setCurrentTime] = useState('0:00');
  const [duration, setDuration] = useState('0:00');

  const videoId = process.env.REACT_APP_CNT_VIDEO_ID || 'S3WTJoSoLxg';
  const testId = 'Gipdt4qC-Dk';

  const { name=user?.name, mobile=user?.mobile, whatsapp=user?.whatsapp, email=user?.email, state=user?.state, district=user?.district, city=user?.city, pinCode=user?.pinCode } = location.state || {};

  const finalId = user?.name === 'ariseupp7Test' ? testId : videoId;
  const { country, language } = useLanguage();
  useEffect(() => {
    const loadYouTubeAPI = () => {
      if (!(window as any).YT) {
        const tag = document.createElement('script');
        tag.src = 'https://www.youtube.com/iframe_api';
        document.body.appendChild(tag);
      } else {
        // If YT is already loaded, call directly
        createPlayer();
      }

      (window as any).onYouTubeIframeAPIReady = () => {
        createPlayer();
      };
    };
  
    const createPlayer = () => {
      if (!videoRef.current) return;
      playerRef.current = new (window as any).YT.Player('youtube-player', {
        videoId: finalId,
        playerVars: {
          enablejsapi: 1,
          controls: 0,
          modestbranding: 1,
          rel: 0,
          iv_load_policy: 3,
        },
        events: {
          onReady: () => {
            playerRef.current.setVolume(volume);
          },
          onStateChange: async (event: any) => {
            if (event.data === window.YT.PlayerState.ENDED) {
              await updateVideoForm(mobile, whatsapp, "CNT_VIDEO", "CNT_VIDEO_COMPLETED");
              navigate('/userInFormatin');
            }
          },
        },
      });
    };

    loadYouTubeAPI();

    const interval = setInterval(() => {
      if (playerRef.current && playerRef.current.getCurrentTime) {
        const current = playerRef.current.getCurrentTime();
        const total = playerRef.current.getDuration();
        setCurrentTime(formatTime(current));
        setDuration(formatTime(total));
      }
    }, 1000);
    
    // ✅ Cleanup
    return () => {
      clearInterval(interval);
      if (playerRef.current && playerRef.current.destroy) {
        playerRef.current.destroy();
      }
      delete (window as any).onYouTubeIframeAPIReady;
    };
  }, [finalId, navigate]);

  const formatTime = (time: number): string => {
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60);
    return `${minutes}:${seconds.toString().padStart(2, '0')}`;
  };

  const handleWatchLater = async (e: React.MouseEvent) => {
    e.preventDefault();
    //setUser({ name, mobile, whatsapp, language, email, country, state, district, city, pinCode });
    
    setUser({ ...user});
    setLoading(true);
    try {
      await sendCntVideo(name, mobile, whatsapp, email);
      navigate('/videoCloseForm');
    } catch (error) {
      console.error("Failed to send video data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handlePlayPause = () => {
    if (playerRef.current) {
      if (isPlaying) {
        playerRef.current.pauseVideo();
      } else {
        playerRef.current.playVideo();
      }
      setIsPlaying(!isPlaying);
    }
  };

  const handleVolumeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newVolume = parseInt(e.target.value, 10);
    setVolume(newVolume);
    if (playerRef.current) {
      playerRef.current.setVolume(newVolume);
      if (newVolume === 0) {
        setIsMuted(true);
      } else {
        setIsMuted(false);
      }
    }
  };

  const toggleMute = () => {
    if (playerRef.current) {
      if (isMuted) {
        playerRef.current.unMute();
        playerRef.current.setVolume(volume);
        setIsMuted(false);
      } else {
        playerRef.current.mute();
        setIsMuted(true);
      }
    }
  };

  const getVolumeIcon = () => {
    if (isMuted || volume === 0) return '🔇';
    if (volume < 40) return '🔈';
    if (volume < 80) return '🔉';
    return '🔊';
  };

  const disableRightClick = (e: React.MouseEvent) => {
    e.preventDefault();
  };

  return (
    <div className="div-container">
      <div style={{ display: 'flex', height: '60vh', width: '100%' }}>
        <div style={{ width: '100%' }}>
          {/* ✅ Video Embed With Overlay */}
          <div
            ref={videoRef}  onClick={handlePlayPause} 
            style={{
              position: 'relative',
              width: '100%',
              height: '300px',
              overflow: 'hidden',
            }}
          >
            <div id="youtube-player" />
            {/* Transparent Overlay to Disable Clicks */}
            <div
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                zIndex: 2,
                cursor: 'not-allowed',
              }}
              onClick={(e) => e.preventDefault()}
              onContextMenu={disableRightClick}
            />
          </div>

          {/* 🎛️ Custom Controls */}
          <div className="video-controls" style={{ display: 'flex', alignItems: 'center', marginTop: '0px', gap: '10px' }}>
            <button className="video-play-button" onClick={handlePlayPause}>
              {isPlaying ? '❚❚' : '▶'}
            </button>

            <span className="video-volume-label" onClick={toggleMute} style={{ cursor: 'pointer' }} title={isMuted ? 'Unmute' : 'Mute'}>
              {getVolumeIcon()}
            </span>

            <input
              id="volume"
              type="range"
              min="0"
              max="100"
              value={isMuted ? 0 : volume}
              onChange={handleVolumeChange}
              className="video-volume-slider"
            />

            <span className="video-timer">{currentTime} / {duration}</span>
          </div>

          {/* 📺 Watch Later Link */}
          <p>
            If you want to watch the video later, click
            <a onClick={handleWatchLater} style={{ color: '#e83026', cursor: 'pointer', marginLeft: '5px' }}>watch later</a>.
          </p>
        </div>
      </div>
    </div>
  );
};

export default VideoFormCnt;